import { action } from 'satcheljs';

/**
 * Action invoked when interacts with 'Mail' menu item
 */
export const launchNewMail = action('launchNewMail', (actionSource: string) => ({ actionSource }));
